import { render, staticRenderFns } from "./PayFees.vue?vue&type=template&id=023a4686&"
import script from "./PayFees.vue?vue&type=script&lang=js&"
export * from "./PayFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports